export default __webpack_public_path__ + "media/images/lp/img1-8cf56332f380b0d901624ed0d1fd067c.png";